import {
  EditorView,
  keymap,
  lineNumbers,
  highlightActiveLine,
  highlightActiveLineGutter,
} from "@codemirror/view";
import { EditorState } from "@codemirror/state";
import {
  defaultKeymap,
  history,
  historyKeymap,
  indentWithTab,
} from "@codemirror/commands";
import { html } from "@codemirror/lang-html";
import {
  syntaxHighlighting,
  defaultHighlightStyle,
  bracketMatching,
} from "@codemirror/language";

// EditorJS raw HTML block with CodeMirror editor. Block type "raw", data { html }.
class RawHtmlTool {
  static get toolbox() {
    return {
      title: "Raw HTML",
      icon: '<svg width="17" height="15" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 4l-6 8 6 8 1.5-1.2L4.8 12l4.7-6.8L8 4zm8 0l-1.5 1.2L19.2 12l-4.7 6.8L16 20l6-8-6-8z" fill="currentColor"/></svg>',
    };
  }

  constructor({ data }) {
    this.data = { html: data && data.html ? data.html : "" };
    this.wrapper = null;
    this.view = null;
  }

  render() {
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("raw-html-tool");

    this.view = new EditorView({
      state: EditorState.create({
        doc: this.data.html,
        extensions: [
          lineNumbers(),
          highlightActiveLine(),
          highlightActiveLineGutter(),
          history(),
          bracketMatching(),
          keymap.of([...defaultKeymap, ...historyKeymap, indentWithTab]),
          html(),
          syntaxHighlighting(defaultHighlightStyle),
          EditorView.lineWrapping,
          EditorView.theme({
            "&": {
              fontSize: "12px",
              border: "1px solid #e2e5e9",
              borderRadius: "4px",
              backgroundColor: "#f8f9fa",
            },
            ".cm-content": {
              fontFamily: "Menlo, Monaco, Consolas, monospace",
              padding: "8px 0",
            },
            ".cm-gutters": {
              backgroundColor: "#f0f2f5",
              border: "none",
            },
            "&.cm-focused": {
              outline: "none",
              borderColor: "#1BACE4",
            },
          }),
        ],
      }),
      parent: this.wrapper,
    });

    // Keep EditorJS block-level keyboard handling (Enter/arrows) from
    // stealing events while editing code.
    this.wrapper.addEventListener("keydown", (event) => {
      event.stopPropagation();
    });

    // Stop paste events from bubbling to EditorJS: it would also handle the
    // paste and insert the same HTML again (duplicated content or an extra
    // block below). CodeMirror handles the paste itself.
    this.wrapper.addEventListener("paste", (event) => {
      event.stopPropagation();
    });

    return this.wrapper;
  }

  save() {
    return {
      html: this.view ? this.view.state.doc.toString() : this.data.html,
    };
  }

  destroy() {
    if (this.view) {
      this.view.destroy();
      this.view = null;
    }
  }
}

export default RawHtmlTool;
